import { Card, Button, SvgIcon } from '@mui/material';
import { RiAddLine } from '@remixicon/react';
import { MouseEventHandler } from 'react';
import { useLanguage } from '../contexts/language';

export interface AddButtonCardProps {
  className?: string;
  onClick: MouseEventHandler;
  disabled?: boolean;
}

const AddButtonCard = ({
  className,
  onClick,
  disabled,
}: AddButtonCardProps) => {
  const { t } = useLanguage();
  return (
    <Card className={className}>
      <Button
        size="small"
        disabled={disabled}
        onClick={onClick}
        startIcon={<SvgIcon component={RiAddLine} />}
        fullWidth
      >
        {t('content.add')}
      </Button>
    </Card>
  );
};

export default AddButtonCard;
